module.exports = __webpack_public_path__ + "static/media/vf-button-pants.7ced0c48.svg";